<template>
  <div class="settings q-px-md">
    <div class="q-my-md">
      <!-- ALTERAÇÃO DE SENHA -->
      <q-expansion-item
        group="settingGroup"
        icon="fas fa-key"
        label="Alterar Senha"
        header-class="bg-verde text-white"
        expand-icon-class="text-white"
      >
        <q-card class="bg-white bLBR">
          <q-card-section class="respRowForm">
            <!-- NOVA SENHA -->
            <q-input
              dense
              outlined
              class="twoFields"
              v-model="newPsw"
              :type="isNewPwd ? 'password' : 'text'"
              label="Nova Senha"
              :rules="[val => val.length >= 6 || 'Favor informar senha de no mínimo 6 dígitos']"
            >
              <template v-slot:append>
                <q-icon
                  :name="isNewPwd ? 'visibility' : 'visibility_off'"
                  @click="isNewPwd = !isNewPwd"
                />
              </template>
            </q-input>
            <!-- CONFIRMAR NOVA SENHA -->
            <q-input
              dense
              outlined
              class="twoFields"
              v-model="rNewPsw"
              :type="isRNewPwd ? 'password' : 'text'"
              label="Confirmar Senha"
              :rules="[val => val.length >= 6 || 'Favor informar senha de no mínimo 6 dígitos']"
            >
              <template v-slot:append>
                <q-icon
                  :name="isRNewPwd ? 'visibility' : 'visibility_off'"
                  @click="isRNewPwd = !isRNewPwd"
                />
              </template>
            </q-input>
          </q-card-section>
          <q-card-section>
            <q-btn no-caps label="Alterar Senha" @click="onChangePsw" style="background-color: var(--primary); color: white;" />
          </q-card-section>
        </q-card>
      </q-expansion-item>

      <q-space class="q-mt-xs" />

      <!-- CADASTROS DE CATEGORIAS -->
      <q-expansion-item
        group="settingGroup"
        icon="fas fa-tags"
        label="Controle de Categorias"
        header-class="bg-verde text-white"
        expand-icon-class="text-white"
      >
        <q-card class="bg-white bLBR">
          <q-card-section class="respRowForm column">
            
            <!-- FAIXA DE CONTROLE -->
            <div class="btns q-mt-md row justify-center">
              <q-btn
                no-caps
                icon="fas fa-tag"
                label="Nova Categoria"
                @click="onNewCategory"
                style="width: 220px; background-color: var(--primary)"
                class="q-mb-md q-mx-md text-white"
              />
            </div>

            <!-- TABELA DE CATEGORIA -->
            <div class="table">
              <q-table
                dense
                class="myTable"
                :rows="rowsCategory"
                :columns="colsCategory"
                row-key="name"
                :rows-per-page-options="[10, 20, 50, 100, 99999]"
                rows-per-page-label="Linhas por página: "
                :filter="filterCategory"
                no-results-label="Sem dados a serem mostrados"
                no-data-label="Sem dados a serem mostrados"
                @row-click="onEditRowCategory"
              >
                <template v-slot:top-left>
                  <q-input filled dense dark v-model="filterCategory" placeholder="Pesquisar" style="width: 150px">
                    <template v-slot:append>
                      <q-icon name="search" />
                    </template>
                  </q-input>
                </template>
              </q-table>
            </div>

          </q-card-section>
        </q-card>
      </q-expansion-item>

      <q-space class="q-mt-xs" />

      <!-- SELEÇÃO DAS LIGAS -->
      <q-expansion-item
        group="settingGroup"
        icon="security"
        label="Selecionar Ligas"
        header-class="bg-verde text-white"
        expand-icon-class="text-white"
      >
        <q-card class="bg-white bLBR">
          <q-card-section>
            <div class="q-mb-md">
              <q-btn
                icon="save"
                label="Salvar"
                no-caps
                dense
                class="q-px-xl"
                style="background-color: var(--primary); color: white"
                @click="onSaveChooseLeagues()"
              />
            </div>
            <div class="containerLeague row">
              <div class="halfScreen">
                <div class="bg-red text-white">Ocultos</div>
                <div class="column items-center">
                  <div
                    v-for="disabled in disabledCategories"
                    :key="disabled"
                    class="styleChipDisabled cursor-pointer row justify-between"
                    @click="onAddLeague(disabled.name)"
                  >
                    {{ disabled.name }}
                    <div class="column justify-center">
                      <q-icon name="add_circle" size="sm" color="green" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="halfScreen">
                <div class="bg-green text-white">Visíveis</div>
                <div class="column items-center">
                  <div
                    v-for="actived in activedCategories"
                    :key="actived"
                    class="styleChipActived row justify-between"
                    @click="onRemoveLeague(actived)"
                  >
                    <div class="column justify-center">
                      <q-icon name="remove_circle" size="sm" color="red" />
                    </div>
                    {{ actived }}
                  </div>
                </div>
              </div>
            </div>
          </q-card-section>
        </q-card>
      </q-expansion-item>

      <q-space class="q-mt-xs" />
      
      <!-- PERFIL DO CATÁLOGO -->
      <q-expansion-item
        group="settingGroup"
        icon="photo_album"
        label="Perfil do Catálogo"
        header-class="bg-verde text-white"
        expand-icon-class="text-white"
      >
        <q-card class="bg-white bLBR">
          <q-card-section>
            <div class="q-gutter-xl">
              <q-radio
                v-model="optCatalog"
                checked-icon="task_alt"
                unchecked-icon="panorama_fish_eye"
                val="sem"
                label="Catálogo SEM Preços" 
                @click="alterPerfilCatalog('without')"
              />
              <q-radio
                v-model="optCatalog"
                checked-icon="task_alt"
                unchecked-icon="panorama_fish_eye"
                val="com"
                label="Catálogo COM Preços*"
                @click="alterPerfilCatalog('with')"
              />
            </div>
          </q-card-section>

          <q-card-section v-show="optCatalog === 'com'">
            <div class="bA">
              <div class="col q-pt-lg q-px-lg justify-between">
                <q-select
                  class="q-my-sm"
                  v-model="folders"
                  outlined
                  :options="optFolders"
                  label="Selecionar Categoria"
                />
                <q-btn
                  icon="check"
                  label="IR"
                  @click="chooseFolder"
                  style="width: 100px; background-color: var(--primary); color: white"
                />
              </div>

              <div class="text-red text-caption text-bold text-italic text-right q-px-lg q-mb-lg">* Itens SEM PREÇO não serão exibidos no Catálogo</div>

              <div class="q-gutter-x-md q-my-sm q-mx-lg row justify-start" v-show="itemsStorage">
                <q-btn
                  style="background-color: var(--primary); color: white"
                  no-caps
                  label="Gravar Alterações"
                  @click="onBurnChanges()"
                />
              </div>

              <div class="col q-mx-lg">
                <div v-for="(item, idx) in itemsStorage" :key="idx">
                  <div
                    class="
                      bCards
                      q-mx-sm
                      q-my-sm
                      q-pa-sm
                      justify-between
                      row
                      full-width
                    "
                    :class="{'bg-green-1': item.newProduct, 'bg-white': !item.newProduct}"
                  >
                    <div :class="{'row justify-center full-width': isMobile}">
                      <q-img
                        class="imgCard"
                        :src="item.url"
                        :ratio="1"
                        spinner-color="primary"
                        spinner-size="82px"
                        width="150px"
                        height="150px"
                        loading="lazy"
                      />
                    </div>
                    <div class="column justify-center" :class="{'full-width': isMobile}">
                      <div class="text-h6 text-bold text-center">{{ item.title }}</div>
                      <div class="text-subtitle1 text-center">{{ item.subTitle }}</div>
                    </div>
                    <div class="q-gutter-y-sm" :class="{'row justify-center': isMobile}">
                      <q-input
                        v-model="item.priceSales"
                        outlined
                        dense
                        type="text"
                        label="Preço de Venda"
                      />
                      <q-input
                        v-model="item.pricePromotional"
                        outlined
                        dense
                        type="text"
                        label="Preço Promocional"
                      />
                      <div>
                        <q-toggle
                          v-model="item.freeShipping"
                          label="Frete Grátis"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="q-gutter-x-md q-my-sm q-mx-lg row justify-start" v-show="itemsStorage">
                <q-btn
                  style="background-color: var(--primary); color: white"
                  no-caps
                  label="Gravar Alterações"
                  @click="onBurnChanges()"
                />
                <q-btn
                  style="background-color: var(--primary); color: white"
                  no-caps
                  label="Ir para Topo"
                  @click="onGoToTop()"
                />
              </div>
            </div>
          </q-card-section>
        </q-card>
      </q-expansion-item>


      <q-space class="q-mt-xs" />
      
      <!-- CADASTRAR WHATSAPP -->
      <q-expansion-item
        group="settingGroup"
        icon="fab fa-whatsapp"
        label="Cadastrar Whatsapp"
        header-class="bg-verde text-white"
        expand-icon-class="text-white"
      >
        <q-card class="bg-white bLBR">
          <q-card-section>
            <div class="respRowForm">
              <!-- NÚMERO WHATSAPP -->
              <q-input
                dense
                outlined
                class="twoFields"
                v-model="numWhats"
                type="number"
                label="Número Whatsapp"
                :rules="[
                  val => val.length >= 10 || 'Favor informar o número com no mínimo 10 dígitos',
                  val => val[0] !== '0' || 'Utilizar o DDD com apenas 2 dígitos (suprimir o zero)',
                ]"
              />

              <!-- ORIENTAÇÕES -->
              <q-input
                dense
                outlined
                readonly
                class="twoFields"
                label="Exemplo de números"
                v-model="exampleWhats"
              />
            </div>

            <div>
              <div class="text-red text-bold text-italic text-subtitle1">
                Regras para cadastrar número:
              </div>
              <q-list class="row" bordered>
                <q-item>
                  <q-item-section>
                    <q-item-label class="text-bold">Regra do DDD</q-item-label>
                    <q-item-label caption lines="2">O DDD deve conter apenas 2 dígitos, portanto devemos suprimir o 0 (zero) inicial</q-item-label>
                  </q-item-section>

                  <q-separator spaced inset />

                  <q-item-section>
                    <q-item-label class="text-bold">Regras do Número</q-item-label>
                    <q-item-label caption lines="2">Se celular sempre incluir o 9 inicial (número deve conter 9 dígitos), se fixo deve conter 8 dígitos. Nunca utilize o hífen para separar o número </q-item-label>
                  </q-item-section>
                </q-item>
              </q-list>
            </div>

            <!-- MENSAGEM PADRÃO -->
            <q-input
              outlined
              v-model="msgWhats"
              type="textarea"
              label="Texto padrão"
              class="q-mt-lg"
            />
          </q-card-section>
          <q-card-section>
            <q-btn no-caps label="Cadastrar Whatsapp" @click="onRegisterWhats" style="background-color: var(--primary); color: white;" />
          </q-card-section>
        </q-card>
      </q-expansion-item>
      
      <q-space class="q-mt-xs" />

      <!-- ESCOLHA DE UM TEMA -->
      <q-expansion-item
        group="settingGroup"
        icon="fas fa-palette"
        label="Escolher Tema"
        header-class="bg-verde text-white"
        expand-icon-class="text-white"
      >
        <q-card class="bg-white bLBR">
          <q-card-section class="respRowForm q-gutter-sm">
            <div class="respRowForm justify-around">
              <q-radio
                v-for="opt in optTheme"
                :key="opt"
                v-model="theme"
                :val="opt.value"
                :label="opt.label"
                @click="onTheme(opt.value)"
              />
            </div>
          </q-card-section>
          <q-card-section>
            <q-btn no-caps label="Alterar Tema" @click="onChangeTheme" style="background-color: var(--primary); color: white;" />
          </q-card-section>
        </q-card>
      </q-expansion-item>

      <q-space class="q-mt-xs" />

      <!-- MISSÃO, VISÃO E VALORES -->
      <q-expansion-item
        group="settingGroup"
        icon="fas fa-bullseye"
        label="Missão, Visão e Valores"
        header-class="bg-verde text-white"
        expand-icon-class="text-white"
      >
        <q-card class="bg-white bLBR">
          <q-card-section class="respRowForm q-gutter-sm">
            <q-input dense outlined class="threeFields" v-model="missao" type="textarea" label="Missão" />
            <q-input dense outlined class="threeFields" v-model="visao" type="textarea" label="Visão" />
            <q-input dense outlined class="threeFields" v-model="valor" type="textarea" label="Valores" />
          </q-card-section>
          <q-card-section>
            <q-btn no-caps label="Cadastrar/Alterar Dados" @click="onMVV" style="background-color: var(--primary); color: white;" />
          </q-card-section>
        </q-card>
      </q-expansion-item>

      <q-space class="q-mt-xs" />

      <!-- CONTATOS -->
      <q-expansion-item
        group="settingGroup"
        icon="fas fa-file-signature"
        label="Entre em Contato"
        header-class="bg-verde text-white"
        expand-icon-class="text-white"
      >
        <q-card class="bg-white bLBR">
          <q-card-section class="respRowForm q-gutter-sm">
            <q-input dense outlined class="threeFields" v-model="title" type="text" label="Assunto" />
            <q-input dense outlined class="threeFields" v-model="mail" type="mail" label="E-Mail" />
            <q-input dense outlined class="threeFields" v-model="phone" type="text" label="Celular" />
          </q-card-section>
          <q-card-section class="respRowForm q-gutter-sm">
            <q-select class="oneFields" v-model="category" :options="optCategory" label="Categoria" outlined />
          </q-card-section>
          <q-card-section class="respRowForm q-gutter-sm">
            <q-input dense outlined class="oneFields" v-model="body" type="textarea" label="Mensagem" />
          </q-card-section>
          <q-card-section>
            <q-btn no-caps label="Enviar Mensagem" @click="onContact" style="background-color: var(--primary); color: white;" />
          </q-card-section>
        </q-card>
      </q-expansion-item>

      <q-space class="q-mt-xs" />

      <!-- SOBRE -->
      <q-expansion-item
        group="settingGroup"
        icon="fas fa-info"
        label="Sobre"
        header-class="bg-verde text-white"
        expand-icon-class="text-white"
      >
        <q-card class="bg-white bLBR">
          <q-card-section class="bg-verdeclaro">
            <q-img
              src="../../../assets/logo_gestaosistema.png"
              width="30%"
            />
            <div class="text-subtitle2 text-italic text-bold">
              {{ 'Versão: ' + version }}
            </div>
            <div class="text-subtitle1 q-my-lg">
              A melhor solução de gestão para Artigos Esportivos.
              <br>
              Tudo ao seu alcance buscando sempre atender as
              <br>
              necessidades dos clientes e facilitar as rotinas diárias
            </div>
            
          </q-card-section>
        </q-card>
      </q-expansion-item>

      <q-space class="q-mt-xs" />
    </div>

    <!-- MODAL PARA INSERÇÃO DE NOVA CATEGORIA -->
    <q-dialog v-model="modalCategory" persistent>
      <div class="bg-white q-pa-lg q-gutter-y-sm" style="width: 500px">
        <div v-if="editRow" class="title text-h5 text-bold text-center text-verde q-mb-md">
          EDITANDO CATEGORIA
        </div>
        <div v-else class="title text-h5 text-bold text-center text-verde q-mb-md">
          INCLUSÃO DE NOVA CATEGORIA
        </div>

        <q-separator spaced size="5px" style="background-color: var(--primary)" />
        
        <q-scroll-area style="width: 100%; height: 60vh;" v-show="rebuild">

          <div class="respRowForm q-gutter-y-sm q-mt-sm">
            <q-input class="oneFields full-width" outlined v-model="newCategory" type="text" label="Categoria" />
          </div>
          <div class="respRowForm q-gutter-y-sm q-mt-sm q-mb-lg">
            <q-select 
              class="oneFields"
              v-model="typeCategory"
              :options="['Padrão', 'Numérico', 'Genérico']" label="Tipo*" outlined
            />
          </div>

          <q-separator color="primary" spaced inset size="3px" />

          <div class="legenda">
            <div class="text-caption text-red">* O tamanho dos itens cadastrados em cada Categoria respeitará a seguinte mecânica:</div>
            <div class="text-caption text-red"><strong>Padrão:</strong> P, M, G, ... (Ex.: Camisas)</div>
            <div class="text-caption text-red"><strong>Numérico:</strong> Apenas números (Ex.: Chuteiras)</div>
            <div class="text-caption text-red"><strong>Genérico:</strong> O campo ficará livre (Ex: Acessórios como Relógios, Bonés, etc)</div>
          </div>

        </q-scroll-area>

        <div class="btns row justify-center q-pt-md">
          <q-btn outline no-caps color="negative" label="Cancelar" @click="onCancelCategory" />
          <div class="q-mx-md" />
          <q-btn outline no-caps color="primary" label="Salvar" @click="onSaveCategory" />
          <div class="q-mx-md" />
          <q-btn v-show="editRow" no-caps color="negative" label="Excluir" @click="onDeletCategory" />
        </div>
      </div>
    </q-dialog>

  </div>
</template>

<script>
import { supabase } from '../../../supabase';
import { Dialog } from 'quasar';
import { mapActions } from 'vuex';
import { defaultColor } from '../../../helpers/defaultColor';
import { version } from '../../../../package.json';
import removeExtensions from '../../../helpers/removeExtensions.js';

export default {
  data() {
    return {
      version: version,
      enterprise: localStorage.getItem('enterprise'),
      // isOldPwd: true,
      isNewPwd: true,
      isRNewPwd: true,
      // oldPsw: null,
      newPsw: null,
      rNewPsw: null,
      theme: null,
      optTheme: [
        { label: 'Tema Padrão       ', value: 'default'   },
        { label: 'Tema Escuro       ', value: 'dark'      },
        { label: 'Tema Claro        ', value: 'light'     },
        { label: 'Tema Azul         ', value: 'blue'      },
        { label: 'Tema Rosa         ', value: 'pink'      },
        { label: 'Tema Ensolarado   ', value: 'sunshine'  },
        { label: 'Tema Antigo       ', value: 'older'     },
        { label: 'Tema Quente       ', value: 'hot'       },
        { label: 'Tema Vermelho     ', value: 'red'       },
        { label: 'Tema Dourado      ', value: 'gold'      },
      ],
      missao: null,
      visao: null,
      valor: null,
      title: null,
      mail: null,
      phone: null,
      body: null,
      category: null,
      optCategory: [
        'Sugestão / Reclamação / Elogíos', 'Suporte sobre a ferramenta', 'Indicação', 'Ýrea Comercial', 'Outros'
      ],

      rowsCategory: [],
      colsCategory: [
        { name: 'GE_DESCRIPTION',  align: 'center',  label: 'Descrição', field: 'GE_DESCRIPTION', sortable: true },
        { name: 'GE_TYPE',         align: 'center',  label: 'Tipo',      field: 'GE_TYPE',        sortable: true },
        { name: 'QTDADE',          align: 'center',  label: 'Qtd Venda', field: 'QTDADE',         sortable: true },
      ],
      filterCategory: null,

      activedCategories: [],
      disabledCategories: [],

      numWhats: null,
      msgWhats: null,
      exampleWhats: '11987654321 ou 1133210987',
      errorNumWhats: null,

      //~> PARA MODAL DAS CATEGORIAS
      modalCategory: false,
      editRow: false,
      rebuild: true,
      newCategory: null,
      typeCategory: null,
      recno: null,

      //~> PARA PRECIFICAR CATÁLOGO
      perfilCatalogDB: null,
      optCatalog: 'sem',
      optFolders: [
        'Babybody', 'Camisas NFL', 'Casual', 'Chuteiras/Campo', 'Chuteiras/Salao', 'Chuteiras/Society', 'Chuteiras/Trava Mista',
        'Conjuntos/Passeio', 'Conjuntos/Treino', 'Corta Vento', 'Femininas', 'Formula 1', 'Kit Infantil',
        'Luvas de Goleiro', 'Meias', 'Moto GP', 'Polo', 'Regatas Futebol', 'Regatas NBA', 'Retro', 'Short/Short de Jogo', 'Short/Short NBA', 'Short/Short de Treino',
        'Tenis/Adidas', 'Tenis/Balenciaga', 'Tenis/Gucci', 'Tenis/New Balance', 'Tenis/Nike',
        'Versao Jogador/Brasileirao', 'Versao Jogador/Bundesliga', 'Versao Jogador/La Liga', 'Versao Jogador/Liga MX', 'Versao Jogador/Ligue 1', 'Versao Jogador/MLS',
        'Versao Jogador/Outras Ligas', 'Versao Jogador/Premier League',  'Versao Jogador/SAF',  'Versao Jogador/Selecoes',  'Versao Jogador/Serie A',
        'Versao Torcedor/Brasileirao', 'Versao Torcedor/Bundesliga', 'Versao Torcedor/La Liga', 'Versao Torcedor/Liga MX', 'Versao Torcedor/Ligue 1', 'Versao Torcedor/MLS',
        'Versao Torcedor/Outras Ligas', 'Versao Torcedor/Premier League',  'Versao Torcedor/SAF',  'Versao Torcedor/Selecoes',  'Versao Torcedor/Serie A',
      ],
      folders: null,
      pricedItems: null,
      priceSell: [],
      itemsStorage: null,
      itemsDatabase: null,
      summerItems: null

    }
  },
  computed: {
    isMobile() {
      return (this.$q.screen.sm || this.$q.screen.xs);
    },
  },
  methods: {
    ...mapActions('Functions', [ 'rpc', 'burnDatas' ]),
    ...mapActions('Querys', [ 'insertData', 'updateData', 'getDataWithoutFilters', 'getDataWithFilters' ]),
    async alterPerfilCatalog(oldPerfil) {
      var newPerfil;

      Dialog.create({
        title: 'Fature Catálogo',
        message: 'Deseja realmente mudar o Perfil do seu Catálogo?',
        ok: 'Sim',
        cancel: 'Não'
      }).onOk(async () => {
        if(this.optCatalog === 'com') {
          newPerfil = 'with';
        } else {
          newPerfil = 'without';
        }

        await supabase
          .from('GE_SETTINGS')
            .update({'GE_PRICEINCATALOG': newPerfil})
              .match({'GE_ENTERPRISE': this.enterprise})
      }).onCancel(() => {
        if(oldPerfil === 'with') {
          this.optCatalog = 'sem';
        } else {
          this.optCatalog = 'com';
        }
      })

    },
    async onBurnChanges() {

      const burn = await this.burnDatas({
        "items": this.itemsStorage,
        "enterprise": this.enterprise,
        "folder": this.folders
      });

      if(burn[0].RECNO > 0) {
        Dialog.create({
          title: 'Gestão Esportes',
          message: 'Alterações gravadas com sucesso!'
        })
      } 

    },
    onGoToTop() {
      window.scrollTo(0,0);
    },
    async chooseFolder() {
      await this.onSummerItems();
    },
    async onSummerItems() {
      await this.productsStorage()
      await this.productsDatabase()
      
      const arrItems = []
      this.itemsStorage.forEach(item => {
        const element = this.itemsDatabase.find(el => el.name === item.name);

        if(JSON.stringify(element) !== undefined) {
          arrItems.push(element);
        } else {
          arrItems.push(item);
        }
      })

      console.log(arrItems);
      this.itemsStorage = arrItems;
    },
    async productsDatabase() {
      const dbProd = await supabase
        .from('GE_SETTINGS')
        .select(String(this.folders).toLowerCase().replace('/', ''))
        .eq('GE_ENTERPRISE', this.enterprise)

      if(dbProd?.data[0]) {
        switch (this.folders) {
          case 'Babybody':
            this.itemsDatabase = dbProd.data[0]?.babybody
            break;
          case 'Camisas NFL':
            this.itemsDatabase = dbProd.data[0]?.camisasnfl
            break;
          case 'Casual':
            this.itemsDatabase = dbProd.data[0]?.casual
            break;
          case 'Chuteiras/Campo':
            this.itemsDatabase = dbProd.data[0]?.chuteirascampo
            break;
          case 'Chuteiras/Salao':
            this.itemsDatabase = dbProd.data[0]?.chuteirassalao
            break;
          case 'Chuteiras/Society':
            this.itemsDatabase = dbProd.data[0]?.chuteirassociety
            break;
          case 'Chuteiras/Trava Mista':
            this.itemsDatabase = dbProd.data[0]?.chuteirastravamista
            break;
          case 'Conjuntos/Passeio':
            this.itemsDatabase = dbProd.data[0]?.conjuntospasseio
            break;
          case 'Conjuntos/Treino':
            this.itemsDatabase = dbProd.data[0]?.conjuntostreino
            break;
          case 'Corta Vento':
            this.itemsDatabase = dbProd.data[0]?.cortavento
            break;
          case 'Femininas':
            this.itemsDatabase = dbProd.data[0]?.femininas
            break;
          case 'Formula 1':
            this.itemsDatabase = dbProd.data[0]?.formula1
            break;
          case 'Kit Infantil':
            this.itemsDatabase = dbProd.data[0]?.kitinfantil
            break;
          case 'Luvas de Goleiro':
            this.itemsDatabase = dbProd.data[0]?.luvasdegoleiro
            break;
          case 'Meias':
            this.itemsDatabase = dbProd.data[0]?.meias
            break;
          case 'Moto GP':
            this.itemsDatabase = dbProd.data[0]?.motogp
            break;
          case 'Polo':
            this.itemsDatabase = dbProd.data[0]?.polo
            break;
          case 'Regatas Futebol':
            this.itemsDatabase = dbProd.data[0]?.regatasfutebol
            break;
          case 'Regatas NBA':
            this.itemsDatabase = dbProd.data[0]?.regatasnba
            break;
          case 'Retro':
            this.itemsDatabase = dbProd.data[0]?.retro
            break;
          case 'Short/Short de Jogo':
            this.itemsDatabase = dbProd.data[0]?.shortjogo
            break;
          case 'Short/Short NBA':
            this.itemsDatabase = dbProd.data[0]?.shortnba
            break;
          case 'Short/Short de Treino':
            this.itemsDatabase = dbProd.data[0]?.shorttreino
            break;
          case 'Tenis/Adidas':
            this.itemsDatabase = dbProd.data[0]?.tenisadidas
            break;
          case 'Tenis/Balenciaga':
            this.itemsDatabase = dbProd.data[0]?.tenisbalenciaga
            break;
          case 'Tenis/Gucci':
            this.itemsDatabase = dbProd.data[0]?.tenisgucci
            break;
          case 'Tenis/New Balance':
            this.itemsDatabase = dbProd.data[0]?.tenisnewbalance
            break;
          case 'Tenis/Nike':
            this.itemsDatabase = dbProd.data[0]?.tenisnike
            break;
          case 'Versao Jogador/Brasileirao':
            this.itemsDatabase = dbProd.data[0]?.versaojogadorbrasileirao
            break;
          case 'Versao Jogador/Bundesliga':
            this.itemsDatabase = dbProd.data[0]?.versaojogadorbundesliga
            break;
          case 'Versao Jogador/La Liga':
            this.itemsDatabase = dbProd.data[0]?.versaojogadorlaliga
            break;
          case 'Versao Jogador/Liga MX':
            this.itemsDatabase = dbProd.data[0]?.versaojogadorligamx
            break;
          case 'Versao Jogador/Ligue 1':
            this.itemsDatabase = dbProd.data[0]?.versaojogadorligue1
            break;
          case 'Versao Jogador/MLS':
            this.itemsDatabase = dbProd.data[0]?.versaojogadormls
            break;
          case 'Versao Jogador/Outras Ligas':
            this.itemsDatabase = dbProd.data[0]?.versaojogadoroutrasligas
            break;
          case 'Versao Jogador/Premier League':
            this.itemsDatabase = dbProd.data[0]?.versaojogadorpremierleague
            break;
          case 'Versao Jogador/SAF':
            this.itemsDatabase = dbProd.data[0]?.versaojogadorsaf
            break;
          case 'Versao Jogador/Selecoes':
            this.itemsDatabase = dbProd.data[0]?.versaojogadorselecoes
            break;
          case 'Versao Jogador/Serie A':
            this.itemsDatabase = dbProd.data[0]?.versaojogadorseriea
            break;
          case 'Versao Torcedor/Brasileirao':
            this.itemsDatabase = dbProd.data[0]?.versaotorcedorbrasileirao
            break;
          case 'Versao Torcedor/Bundesliga':
            this.itemsDatabase = dbProd.data[0]?.versaotorcedorbundesliga
            break;
          case 'Versao Torcedor/La Liga':
            this.itemsDatabase = dbProd.data[0]?.versaotorcedorlaliga
            break;
          case 'Versao Torcedor/Liga MX':
            this.itemsDatabase = dbProd.data[0]?.versaotorcedorligamx
            break;
          case 'Versao Torcedor/Ligue 1':
            this.itemsDatabase = dbProd.data[0]?.versaotorcedorligue1
            break;
          case 'Versao Torcedor/MLS':
            this.itemsDatabase = dbProd.data[0]?.versaotorcedormls
            break;
          case 'Versao Torcedor/Outras Ligas':
            this.itemsDatabase = dbProd.data[0]?.versaotorcedoroutrasligas
            break;
          case 'Versao Torcedor/Premier League':
            this.itemsDatabase = dbProd.data[0]?.versaotorcedorpremierleague
            break;
          case 'Versao Torcedor/SAF':
            this.itemsDatabase = dbProd.data[0]?.versaotorcedorsaf
            break;
          case 'Versao Torcedor/Selecoes':
            this.itemsDatabase = dbProd.data[0]?.versaotorcedorselecoes
            break;
          case 'Versao Torcedor/Serie A':
            this.itemsDatabase = dbProd.data[0]?.versaotorcedorseriea
            break;
          default:
            break;
        }
      }
    },
    async productsStorage() {
      var arrImages = []
      const { data, error } = await supabase
        .storage
        .from('catalogo')
        .list(this.folders, {
          limit: 9999
        })

      if(data) {
        data.forEach(async file => {
          const folderFile = `${this.folders}/${file.name}`;

          const { publicURL } = supabase
            .storage
            .from('catalogo')
            .getPublicUrl(folderFile)

          const name = String(file.name).split('_');
          const title = name[0]
          const subTitle = removeExtensions(name[1]).name

          arrImages.push({
            ...file,
            url: publicURL,
            title: title,
            subTitle: subTitle,
            freeShipping: false,
            pricePromotional: 0,
            priceSales: 0,
            newProduct: true
          })
        })

        this.itemsStorage = arrImages;
      }

      if(error)
        Dialog.create({
          title: 'Fature Catálogo',
          message: `Erro ao retornar os produtos da Catagoria: ${this.folders}`
        })
    },

    async onChangePsw() { //~> OK
      if(
        this.newPsw == null || this.newPsw == '' || this.newPsw.length < 6 ||
        this.rNewPsw == null || this.rNewPsw == '' || this.rNewPsw.length < 6
      ) {
        Dialog.create({
          title: 'Gestão Esportes',
          message: 'Favor preencher corretamente todos os campos!'
        })
      } else if (
        this.newPsw !== this.rNewPsw
      ) {
        Dialog.create({
          title: 'Gestão Esportes',
          message: 'Favor rever senhas informadas, "Nova Senha" e "Confirmar Senha" devem ser iguais.'
        })
      } else {
        const { user, error } = await supabase
          .auth
          .update({
            password: this.newPsw
          })

        if (error) { Dialog.create({ title: 'Gestão Esportes', message: error.message}) }
        if (user) { Dialog.create({ title: 'Gestão Esportes', message: 'Senha alterada com sucesso!'}) }
      }

    },
    onTheme(value) { //~> OK

      let bodyStyles = document.body.style;
      switch (value) {
        case 'default':
          //~> Cores Primárias
          bodyStyles.setProperty('--primaryLight', '#53906F')
          bodyStyles.setProperty('--primary', '#2E6C4A')
          bodyStyles.setProperty('--primaryDark', '#0D2E1D')
          break;
        case 'dark':
          //~> Cores Primárias
          bodyStyles.setProperty('--primaryLight', '#969696')
          bodyStyles.setProperty('--primary', '#464646')
          bodyStyles.setProperty('--primaryDark', '#000000')
          break;
        case 'light':
          //~> Cores Primárias
          bodyStyles.setProperty('--primaryLight', '#BBBBBB')
          bodyStyles.setProperty('--primary', '#999999')
          bodyStyles.setProperty('--primaryDark', '#8D8D8D')
          break;
        case 'blue':
          //~> Cores Primárias
          bodyStyles.setProperty('--primaryLight', '#625CB3')
          bodyStyles.setProperty('--primary', '#362F93')
          bodyStyles.setProperty('--primaryDark', '#292466')
          break;
        case 'pink':
          //~> Cores Primárias
          bodyStyles.setProperty('--primaryLight', '#FAE1CB')
          bodyStyles.setProperty('--primary', '#EDB5A8')
          bodyStyles.setProperty('--primaryDark', '#E38F9E')
          break;
        case 'sunshine':
          //~> Cores Primárias
          bodyStyles.setProperty('--primaryLight', '#F1C095')
          bodyStyles.setProperty('--primary', '#E9B562')
          bodyStyles.setProperty('--primaryDark', '#C08752')
          break;
        case 'older':
          //~> Cores Primárias
          bodyStyles.setProperty('--primaryLight', '#BD917C')
          bodyStyles.setProperty('--primary', '#966D58')
          bodyStyles.setProperty('--primaryDark', '#74503E')
          break;
        case 'hot':
          //~> Cores Primárias
          bodyStyles.setProperty('--primaryLight', '#F8890A')
          bodyStyles.setProperty('--primary', '#E45151')
          bodyStyles.setProperty('--primaryDark', '#632F8D')
          break;
        case 'red':
          //~> Cores Primárias
          bodyStyles.setProperty('--primaryLight', '#FA7070')
          bodyStyles.setProperty('--primary', '#FC4A4A')
          bodyStyles.setProperty('--primaryDark', '#C00000')
          break;
        case 'gold':
          //~> Cores Primárias
          bodyStyles.setProperty('--primaryLight', '#747272')
          bodyStyles.setProperty('--primary', '#A77D00')
          bodyStyles.setProperty('--primaryDark', '#404040')
          break;
      
        default:
          break;
      }

    },
    async onChangeTheme() { //~> OK
      let recno = localStorage.getItem('recnoClient');
      let theme = this.theme;

      await this.updateData({
        table: 'GE_PERFIL_USERS',
        fields: {
          'GE_DEFAULTCOLOR': theme
        },
        match: {
          'RECNO': recno
        }
      })

      localStorage.setItem('defaultColor', this.theme);

      Dialog.create({
        title: 'Gestão Esportes',
        message: 'Tema alterado com sucesso!'
      })
    },
    async onMVV() { //~> OK
      let enterprise = localStorage.getItem('enterprise');

      let data = await this.getDataWithoutFilters({
        table: 'GE_SETTINGS',
        fields: '*',
        enterprise: enterprise
      })

      if(data.length > 0) {
        await this.updateData({
          table: 'GE_SETTINGS',
          fields: {
            'GE_MISSAO': this.missao,
            'GE_VISAO': this.visao,
            'GE_VALORES': this.valor
          },
          match: {
            'GE_ENTERPRISE': enterprise
          }
        })
      } else {
        await this.insertData({
          table: 'GE_SETTINGS',
          fields: {
            'GE_MISSAO': this.missao,
            'GE_VISAO': this.visao,
            'GE_VALORES': this.valor,
            'GE_ENTERPRISE': enterprise,
            'DELETED': ' '
          }
        })
      }

      Dialog.create({
        title: 'Gestão Esportes',
        message: 'Dados gravados com sucesso!'
      })
    },
    async onContact() { //~> OK
      if(
        this.title    == null || this.title    == '' ||
        this.phone    == null || this.phone    == '' ||
        this.category == null || this.category == '' ||
        this.body     == null || this.body     == ''
      ) {
        Dialog.create({
          title: 'Gestão Esportes',
          message: 'Favor preencher todos os campos.'
        })
      } else {
        await this.insertData({
          table: 'GE_CONTACTS',
          fields: {
            'GE_SUBJECT':     this.title ,
            'GE_MAIL':        this.mail ,
            'GE_PHONE':       this.phone ,
            'GE_CATEGORY':    this.category ,
            'GE_MESSAGE':     this.body ,
            'GE_ENTERPRISE':  localStorage.getItem('enterprise') ,
            'DELETED':        ' ' ,
            'STATUS':         'PENDENTE',
          }
        })

        Dialog.create({
          title: 'Gestão Esportes',
          message: 'Mensagem enviada com sucesso. Em breve entraremos em contato!'
        })

        this.title = ''
        this.mail = ''
        this.phone = ''
        this.category = ''
        this.body = ''
      }
    },
    onNewCategory() {
      this.modalCategory = true;
    },
    async onSaveCategory() {

      if(this.editRow) {
        await supabase
          .from('GE_CATEGORY')
          .update({
            GE_DESCRIPTION: this.newCategory,
            GE_TYPE: this.typeCategory
          })
          .match({
            RECNO: this.recno
          })
      } else {
        await supabase
          .from('GE_CATEGORY')
          .insert({
            GE_DESCRIPTION: this.newCategory,
            GE_TYPE: this.typeCategory,
            GE_ENTERPRISE: this.enterprise,
            DELETED: ' '
          })
      }

      Dialog.create({
        title: 'Gestão Esportes',
        message: 'Categoria cadastrada com sucesso!'
      });
      this.executeQuery();
      this.modalCategory = false;
    },
    onCancelCategory() {
      this.modalCategory = false;
    },
    onEditRowCategory(_, row) {
      if(row.GE_ENTERPRISE === 'ALL') {
        Dialog.create({
          title: 'Gestão Esportes',
          message: 'Esta categoria é padrão do Sistema. Não permitida alteração!',
          cancel: false,
        })

        return
      }

      this.newCategory = row.GE_DESCRIPTION;
      this.typeCategory = row.GE_TYPE;
      this.recno = row.RECNO;

      this.editRow = true;
      this.modalCategory = true;
    },
    async onDeletCategory() {
      await supabase
        .from('GE_CATEGORY')
        .update({
          DELETED: '*'
        })
        .match({
          RECNO: this.recno
        });

      this.modalCategory = false;
      this.executeQuery()
    },
    async executeQuery() { //~> OK
      //~> PARA ALIMENTAR A TABELA DE CATEGORIAS
      let data = await this.rpc({
        function: 'category_vs_sells',
        enterprise: this.enterprise
      })

      this.rowsCategory = data.map(row => {
        return {
          GE_DESCRIPTION: row.descricao,
          GE_TYPE: row.tipo,
          GE_ENTERPRISE: row.empresa,
          RECNO: row.recno,
          QTDADE: row.qtdade
        }
      })


      let enterprise = localStorage.getItem('enterprise');

      let sett = await this.getDataWithoutFilters({
        table: 'GE_SETTINGS',
        fields: '*',
        enterprise: enterprise
      })

      // console.log(sett);

      this.activedCategories = sett[0].GE_CATEGORYS
      this.recno = sett[0].RECNO
      this.numWhats = sett[0].GE_NUMWHATS
      this.msgWhats = sett[0].GE_MSGWHATS

      if(sett) {
        null;
      } else {
        console.error(sett.error.message);
      }

      this.getCategorys()

    },
    async getCategorys() {
      const { data } = await supabase
        .storage
        .from('catalogo')
        .list();

      this.categorys = data;

      // console.log(data);


      this.disabledCategories = this.categorys.filter(el => {
        if(this.activedCategories.indexOf(el.name) === -1)
          return el;
      })
    },
    onAddLeague(league) {
      this.activedCategories.push(league);

      let idx;
      this.disabledCategories.map((item, index) => {
        if(item.name === league)
          idx = index;
      });

      this.disabledCategories.splice(idx, 1);
    },
    onRemoveLeague(league) {
      this.disabledCategories.push({
        name: league
      });

      let idx;
      this.activedCategories.map((item, index) => {
        if(item === league)
          idx = index;
      });

      this.activedCategories.splice(idx, 1);
    },
    async onSaveChooseLeagues() {
      const { data, error } = await supabase
        .from('GE_SETTINGS')
        .update({
          GE_CATEGORYS: this.activedCategories
        })
        .match({
          RECNO: this.recno
        })
      
      if(data) {
        Dialog.create({
          title: 'Gestão Esportes',
          message: 'Alterações salvas com sucesso!',
          cancel: 'OK',
          ok: false
        })
      } else {
        console.error('Erro atualizar Ligas', error.message);
      }
    },
    async onRegisterWhats() {
      if(this.numWhats === null) {
        Dialog.create({
          title: 'Gestão Esportes',
          message: 'Favor preencher o número de Whatsapp conforme regras destacadas!'
        })

        return
      }

      if(this.msgWhats === null || this.msgWhats === '') {
        Dialog.create({
          title: 'Gestão Esportes',
          message: 'Favor preencher o Texto Padrão com uma mensagem a receber ao iniciar um diálogo!'
        })

        return
      }

      const { data, error } = await supabase
        .from('GE_SETTINGS')
        .update({
          GE_NUMWHATS: this.numWhats,
          GE_MSGWHATS: this.msgWhats
        })
        .match({
          GE_ENTERPRISE: this.enterprise
        })

      if(data) {
        Dialog.create({
          title: 'Gestão Esportes',
          message: 'Whatsapp cadastrado com sucesso!'
        })
      }
      if(error) {
        Dialog.create({
          title: 'Gestão Esportes',
          message: 'Não foi possivel gravar o Whatsapp, repita o processo. Se persistir o problema entre em contato com os administradores!'
        })
      }
    },
  },
  async created() {
    defaultColor();
    this.executeQuery();

    let enterprise = localStorage.getItem('enterprise');

    let data = await this.getDataWithoutFilters({
      table: 'GE_SETTINGS',
      fields: '*',
      enterprise: enterprise
    })

    this.missao = data[0].GE_MISSAO
    this.visao = data[0].GE_VISAO
    this.valor = data[0].GE_VALORES
  }
}
</script>

<style lang="scss">
  @import url('../../../globais/GlobalStyles.scss');

  .styleChipDisabled {
    width: 200px;
    /* background-color: rgba(red, $alpha: 0.2); */
    border: 2px solid red;
    border-radius: 0px 20px 20px 0px;
    color: black;
    margin-top: 5px;
    text-align: left;
    font-weight: bold;
    padding-left: 5px;
    padding-right: 1px;
  }
  .styleChipActived {
    width: 200px;
    /* background-color: rgba(green, $alpha: 0.3); */
    border: 2px solid green;
    border-radius: 20px 0px 0px 20px;
    color: black;
    margin-top: 5px;
    text-align: right;
    font-weight: bold;
    padding-left: 1px;
    padding-right: 5px;
  }

  .halfScreen {
    width: 50%;
  }

  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }

  /* Celulares (portrait tablets and large phones, 600px and up) */
  @media only screen and (max-width: 600px) {
    .containerLeague {
      flex-direction: column;
      align-items: center;
    }

    .halfScreen {
      width: 100%;
      margin-top: 20px;
    }
  }
</style>